import * as React from "react";
import { Text } from "grommet";
import { useEffect } from "react";

export function useCountdown(targetDate) {
    const calculateTimeLeft = () => {
        const now = new Date();
        const difference = new Date(targetDate) - now;

        if (difference <= 0) {
            return "Time's up!";
        }

        const timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
        };

        return `${timeLeft.days}d ${timeLeft.hours}h ${timeLeft.minutes}m ${timeLeft.seconds}s`;
    };

    const [countdown, setCountdown] = React.useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer); // Cleanup the timer on component unmount
    }, [targetDate]);

    return countdown;
}

export const Countdown = ({ targetDate, ...props }) => {
    const countdown = useCountdown(targetDate);

    return <Text {...props}>{countdown}</Text>;
};

export default Countdown; // Ensure to export Countdown as default
